module.exports={render:function (){with(this) {
  return _h('div', {
    attrs: {
      "id": "app"
    }
  }, [_h('div', {
    staticClass: "pure-menu pure-menu-horizontal",
    attrs: {
      "id": "header"
    }
  }, [_h('ul', {
    staticClass: "pure-menu-list"
  }, [_h('router-link', {
    staticClass: "pure-menu-item",
    attrs: {
      "tag": "li",
      "to": "/tally"
    }
  }, [_m(0)]), " ", _h('router-link', {
    staticClass: "pure-menu-item",
    attrs: {
      "tag": "li",
      "to": "/tardy"
    }
  }, [_m(1)]), " ", _h('router-link', {
    staticClass: "pure-menu-item",
    attrs: {
      "tag": "li",
      "to": "/honor"
    }
  }, [_m(2)]), " "])]), " ", _h('router-view')])
}},staticRenderFns: [function (){with(this) {
  return _h('a', {
    staticClass: "pure-menu-link"
  }, ["Tally"])
}},function (){with(this) {
  return _h('a', {
    staticClass: "pure-menu-link"
  }, ["Tardy"])
}},function (){with(this) {
  return _h('a', {
    staticClass: "pure-menu-link"
  }, ["Honor"])
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b95a3c34!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 71
// module chunks = 2